import React, {Component} from 'react';
import './TandCComponent.less';

class TandCComponent extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const text = this.props.multiUserEnabled ? `${this.props.lingua.read('copyright')}` : `${this.props.lingua.read('facebook.promise')} ${this.props.lingua.read('copyright')}`;
        return (
            <div className = "TandCComponent text-center col-xs-12" >
                <label dangerouslySetInnerHTML = {{__html: text}} />
            </div>
        );
    }
}

export default TandCComponent;
